import { createContext } from "react";
import { config } from "../../config/config.ts";
import { AuthService } from "../auth/AuthService.ts";
import { ClaService } from "../cla/state/ClaService.ts";
import { InsightsAgentService } from "../insights-agent/state/InsightsAgentService.ts";
import { DeepResearchService } from "../deep-research/state/DeepResearchService.ts";

export const AppContext = createContext<{
  insightsAgentService?: InsightsAgentService;
  deepResearchService?: DeepResearchService;
  claService?: ClaService;
  authService?: AuthService;
  config?: typeof config;
}>({});
